import { useState } from "react";
import { getColorByInitial, getFirstLetterAndConvertToEnglish } from "../../../../services/helpers/Helper";

const AvatarUser = ({ name, onClick, style, className, avatar }) => {
   const [isErr, setIsErr] = useState(false);
   const getFirstCharName = () => {
      if (name) {
         return getFirstLetterAndConvertToEnglish(name);
      }
      return '';
   }

   return (
      <span
         content={name}
         className={`app-avatar app-avatar-circle ${className}`}
         style={{ background: getColorByInitial(getFirstCharName()), width: 32, height: 32, lineHeight: 32, ...style }}
         onClick={onClick}
      >
         {avatar && !isErr ?
            <img src={avatar} onError={() => {
               setIsErr(true);
            }} />
            :
            <span className="app-avatar-string" style={{ lineHeight: 32 }}>{getFirstCharName()}</span>
         }
      </span>
   )
}

export default AvatarUser;